module.exports = function getResource(label, vars = []) {
    let resources = {
        weGotItHeader: 'We got it!',
        orderNumberText: 'Order number',
        pickupOrderNumberText: 'Pickup Order Number',
        orderedMessageText: 'It’s ordered. Check your inbox shortly for a confirmation email.',
        pickupOrderedMessageText: 'You’ll receive a confirmation email with reservation details at',
        continueShoppingButton: 'Continue Shopping',
        cancelOrderButton: 'Cancel Your Order',
        estimatedDelivery: 'Estimated Delivery',
        shipmentText: `Shipment ${vars[0]}`,
        viewBasketButton: 'View Basket',
        certonaTitle: 'People Also Bought',
        shipTo: 'Ship To',
        pickupLocation: 'Pickup Location',
        storeDetails: 'Store Details',
        callStore: 'Call Store',
        seeFAQ: 'See FAQs',
        contactInfo: 'Contact Information',
        pickupBarcodeMsg: 'Show your pickup barcode. You can find it in your email or by opening this page on your mobile device.',
        pickupPerson: 'Pickup Person',
        contactMessage1: 'Please have your ',
        confirmEmail: 'confirmation email ',
        or: 'or ',
        photoId: 'photo ID ',
        ready: 'ready when you pick up your order.'
    };

    return resources[label];
};
